import React from 'react'

const Download = ({ width = 18.333, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18.333 20"
  >
    <path
      fill="#454e5b"
      d="M10.167,17.5,3.5,10h5V0h3.333V10h5Zm7.5-.833v1.667h-15V16.667H1V20H19.333V16.667Z"
      transform="translate(-1)"
    />
  </svg>
)

export default Download
